import { fetchAuthSession } from 'aws-amplify/auth';
import { backendConfig } from '../aws-config';

export const apiRequest = async <T>(path: string, options: RequestInit = {}): Promise<T> => {
  const session = await fetchAuthSession();
  const token = session.tokens?.accessToken?.toString();
  const response = await fetch(`${backendConfig.apiUrl}${path}`, {
    ...options,
    headers: { 'content-type': 'application/json', ...(token ? { authorization: `Bearer ${token}` } : {}), ...options.headers },
  });
  if (!response.ok) throw new Error((await response.json().catch(() => null))?.message || 'Request failed');
  return response.status === 204 ? (undefined as T) : response.json();
};
